/**
 * Gemerkter Teil der Seitenleiste (Ticket 1.261, Auftrag „Kennzahlen · Belegvorschau · Verlauf“): Bedienvorliebe im
 * Browser je Person (Schlüssel mit der Benutzer-Kennung, Muster `case-jump.ts`). Ohne gemerkten Wert oder ohne Speicher
 * gilt der erste Teil; ein unbekannter Wert fällt im Rahmen (`RecordLayout`) ebenfalls auf den ersten Teil zurück.
 * Beim Abmelden löscht `clearPersonalCaches()` alle Werte (`clearSidebarParts`).
 */

const STORAGE_PREFIX = 'till-erp.seitenleiste.';

/** Datensatz-Arten mit gemerktem Teil der Seitenleiste. */
export type SidebarRecord = 'order';

function key(record: SidebarRecord, userId: string): string {
  return `${STORAGE_PREFIX}${record}.${userId}`;
}

export function readSidebarPart(record: SidebarRecord, userId: string): string | null {
  try {
    return window.localStorage.getItem(key(record, userId));
  } catch {
    return null;
  }
}

export function writeSidebarPart(record: SidebarRecord, userId: string, value: string): void {
  try {
    window.localStorage.setItem(key(record, userId), value);
  } catch {
    // Ohne Speicher gilt die Wahl bis zum Neuladen.
  }
}

/** Alle gemerkten Teile vergessen (Abmelden, Personenwechsel). */
export function clearSidebarParts(): void {
  try {
    for (const k of Object.keys(window.localStorage)) if (k.startsWith(STORAGE_PREFIX)) window.localStorage.removeItem(k);
  } catch {
    // Ohne Speicher gibt es nichts zu löschen.
  }
}
